/**
 * URL da discador-api definida pelo host (discador-webview) via window.__DISCADOR_API_URL__.
 * Fallback: VUE_APP_API_URL no build ou localhost.
 */
export function getDiscadorApiUrl() {
  if (typeof window !== 'undefined' && typeof window.__DISCADOR_API_URL__ === 'string') {
    return String(window.__DISCADOR_API_URL__).replace(/\/+$/, '');
  }

  if (
    typeof process !== 'undefined' &&
    process.env &&
    process.env.VUE_APP_API_URL
  ) {
    return String(process.env.VUE_APP_API_URL).replace(/\/+$/, '');
  }

  return 'http://localhost:3000';
}
